import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Form, Input, Modal, Row } from 'antd'
import { NOTE_MAX_LENGTH } from '../../../../modules/brandActivityTransaction'

const BrandHeroNoteForm = (props) => {
  const { visible, loading, formData, onOk, onCancel, form } = props
  const { getFieldDecorator, validateFields, resetFields } = form

  useEffect(() => {
    if (visible) {
      resetFields()
    }
  }, [visible, formData])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields((err, values) => {
      if (!err) {
        // "" = ล้างหมายเหตุ
        onOk(formData.id, values.note || '')
      }
    })
  }

  return (
    <Modal
      title={`หมายเหตุ — ${formData.name || ''}`}
      visible={visible}
      footer={null}
      onCancel={onCancel}
      maskClosable={false}
    >
      <Form onSubmit={onSubmit} layout="vertical">
        <Form.Item
          label="หมายเหตุ"
          extra="หมายเหตุนี้ผูกกับ Hero ในแบรนด์นี้ ทุกรายการของ Hero นี้จะเห็นหมายเหตุเดียวกัน"
        >
          {getFieldDecorator('note', {
            initialValue: formData.note || '',
            rules: [
              {
                max: NOTE_MAX_LENGTH,
                message: `หมายเหตุต้องไม่เกิน ${NOTE_MAX_LENGTH} ตัวอักษร`
              }
            ]
          })(<Input.TextArea rows={4} maxLength={NOTE_MAX_LENGTH} />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <Button type="primary" htmlType="submit" loading={loading}>
              บันทึก
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

BrandHeroNoteForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  formData: PropTypes.object,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedBrandHeroNoteForm = Form.create({ name: 'BrandHeroNoteForm' })(
  BrandHeroNoteForm
)
export default WrappedBrandHeroNoteForm
